import axios from "axios";
import { getUserName } from "../../utils/localStoarege";
import { localToken, patientSearch } from "../../constants/apis/new_hud_apis";

export const searchMasterPatientApi = async (name, branchName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localToken}`,
        },
    };

    const branch = branchName || getUserName();
    const response = await axios.get(
        patientSearch + `?branch_name=${branch}&search_name=${name}`,
        config,
    );

    return response;
};